<template>
    <v-form>
        <v-text-field
            v-model="value.email"
            :rules="rule.email"/>

        <password-field
            v-model="value.password"
            :rules="rule.password"
            @keyup.enter="$emit('submit')"/>
    </v-form>
</template>

<script>
import PasswordField from '@/components/fields/PasswordField'

export default {
    name: 'LoginForm',

    props: {
        value: {
            type: Object,
            default: () => ({})
        }
    },

    components: {
        PasswordField
    },

    data () {
        return {
            rule: {
                email: [
                    this.$validator.required
                ],
                password: [
                    this.$validator.required
                ]
            }
        }
    }
}
</script>

<style lang="scss" scoped></style>
